@if (showPlaceholder) {
  <div class="item-placeholder-wrapper">
    @for (row of rows; track $index) {
      <div class="item-placeholder" [class.multiple-rows]="placeholderRows > 1">
        <div class="item-placeholder-text" [style.maxWidth.rem]="width" [style.height.rem]="height"></div>
      </div>
    }
  </div>
}

@if (!showPlaceholder) {
  <ng-content></ng-content>
}
